import { Box, Flex, Text } from "@chakra-ui/react";
import { format } from "date-fns";
import { useMaterialLogsPaginated } from "../hooks/material.hooks";
import type { Material } from "../types/material.types";

type MaterialLogTreeProps = {
	material: Pick<Material, "id">;
};

const MaterialLogTree = ({ material }: MaterialLogTreeProps) => {
	const logs = useMaterialLogsPaginated(material.id, 1, 100);

	if (logs === undefined || logs === null || logs.data.length === 0) {
		return null;
	}

	const sortedLogs = [...logs.data].sort((a, b) => {
		if (!a.createdAt || !b.createdAt) return 0;
		return new Date(b.createdAt).getTime() - new Date(a.createdAt).getTime();
	});

	return (
		<Box position="relative" py={4}>
			{sortedLogs.length > 1 && (
				<Box
					position="absolute"
					left="3px"
					top="16px"
					width="2px"
					height={`calc(100% - 52px)`}
					bg="gray.200"
				/>
			)}

			{sortedLogs.map((log, index) => {
				const isFirst = index === 0;
				const isLast = index === sortedLogs.length - 1;

				return (
					<Flex
						key={log.id}
						position="relative"
						mb={isLast ? 0 : 6}
						alignItems="center"
					>
						<Box position="relative" mr={4} flexShrink={0} zIndex={1}>
							{/* Circle marker */}
							<Box
								width="8px"
								height="8px"
								borderRadius="full"
								bg={isFirst ? "white" : "brand.500"}
								border={isFirst ? "2px solid" : "none"}
								borderColor="gray.300"
							/>
						</Box>

						{/* Log content */}
						<Flex flex={1} direction="column">
							<Flex alignItems="center" gap={3}>
								<Text fontSize="14px" fontWeight={600}>
									{log.number}
								</Text>
							</Flex>
							{log.createdAt && (
								<Text fontSize="14px" fontWeight={400} color="gray.600" mt={1}>
									{format(new Date(log.createdAt), "dd MMMM yyyy HH:mm")}
								</Text>
							)}
						</Flex>
					</Flex>
				);
			})}
		</Box>
	);
};

export default MaterialLogTree;
